const CHUNK = 4 * 1024 * 1024;
export const MAX_FILE = 100 * 1024 * 1024;

export const fmtSize = (b) => (b >= 1048576 ? `${(b / 1048576).toFixed(1)} MB` : `${Math.max(1, Math.round(b / 1024))} KB`);

const postPart = async (url, fd) => {
  let r;
  for (let a = 0; a < 3; a += 1) {
    r = await fetch(url, { method: 'POST', body: fd });
    if (r.status < 500) break;
  }
  if (!r.ok) {
    const e = await r.json().catch(() => ({}));
    throw new Error(typeof e.detail === 'string' ? e.detail : 'Upload failed — please try again.');
  }
  return r.json();
};

// Sends the file in 4 MB parts so large drawings pass the proxy; resolves with the chat message
export async function uploadChunked(url, file, extra, onProgress) {
  if (file.size > MAX_FILE) throw new Error('Files can be up to 100 MB.');
  const total = Math.max(1, Math.ceil(file.size / CHUNK));
  const uploadId = crypto.randomUUID();
  let last;
  for (let i = 0; i < total; i += 1) {
    const fd = new FormData();
    Object.entries({ ...extra, upload_id: uploadId, index: i, total, size: file.size, filename: file.name }).forEach(([k, v]) => fd.append(k, v));
    fd.append('chunk', file.slice(i * CHUNK, (i + 1) * CHUNK, file.type || 'application/octet-stream'), file.name);
    last = await postPart(url, fd);
    onProgress(Math.round(((i + 1) / total) * 100));
  }
  return last.message;
}
